import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import CartDrawerRoute from "./CartDrawerRoute";

// Only keep storefront browsing pages behind the cart. Never restore an
// external URL, checkout submission route, or stale drawer history marker.
export const cartBackgroundLocation = (location) => {
  const pathname = location?.pathname;
  if (!pathname || !(pathname === "/" || /^\/(category|product|search|favorites)(\/|$)/.test(pathname))) return null;
  const { checkoutV2CartDrawer, cartBackground, ...state } = location.state || {};
  return { pathname, search: location.search || "", hash: location.hash || "", state, key: location.key };
};

export class CartOverlaySwitch extends React.Component {
  state = { previousLocation: null, background: null };

  static getDerivedStateFromProps({ enabled, location }, state) {
    if (!enabled || location.pathname !== "/cart") {
      if (state.previousLocation === location && !state.background) return null;
      return { previousLocation: location, background: null };
    }
    if (state.background) return null;
    return { background: cartBackgroundLocation(location.state?.cartBackground) ||
      cartBackgroundLocation(state.previousLocation) || { pathname: "/", search: "", hash: "" } };
  }

  render() {
    const { children, location } = this.props;
    const { background } = this.state;
    return <>
      <Switch location={background || location}>{children}</Switch>
      {background && <Route location={location} path="/cart" render={(props) =>
        <CartDrawerRoute {...props} backgroundLocation={background} />
      } />}
    </>;
  }
}

export default withRouter(CartOverlaySwitch);
